import {connect} from 'react-redux';
import TabSavedRows from './TabSavedRows';
import {
  step9ChangeTab1ColumnVisibility,
  step9ChangeTab2ColumnVisibility,
  step9ChangeTab3ColumnVisibility,
  step9ChangeTab4ColumnVisibility,
} from '../../actions/steps/step9UpdateColumnDisplay';
import {step9UpdateSavedRowData} from '../../actions/steps/step9UpdateSavedRowData';

const mapStateToProps = ({
                           user: {allowInspectionsShare},
                         }) => ({
  allowInspectionsShare,
});

export default connect(
  mapStateToProps,
  {
    step9ChangeTab1ColumnVisibility,
    step9ChangeTab2ColumnVisibility,
    step9ChangeTab3ColumnVisibility,
    step9ChangeTab4ColumnVisibility,
    step9UpdateSavedRowData,
  }
)(TabSavedRows);
